/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Error_Password_LengthInputs */



/**
* | output |
* | --- |
* | "Password must be at least 8 characters" |
*
* @param {Auth_Verify_Error_Password_LengthInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_error_password_length = /** @type {((inputs?: Auth_Verify_Error_Password_LengthInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Error_Password_LengthInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le mot de passe doit contenir au moins 8 caractères")
	if (locale === "es") return /** @type {LocalizedString} */ ("La contraseña debe tener al menos 8 caracteres")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A senha deve ter no mínimo 8 caracteres")
	if (locale === "it") return /** @type {LocalizedString} */ ("La password deve contenere almeno 8 caratteri")
	return /** @type {LocalizedString} */ ("Password must be at least 8 characters")
});